import { render, staticRenderFns } from "./onebox-register_mohpromt.vue?vue&type=template&id=c8e3e7d6&"
import script from "./onebox-register_mohpromt.vue?vue&type=script&lang=js&"
export * from "./onebox-register_mohpromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports